import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { IncidentDetectionService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  IncidentDetectionCreateDto,
  IncidentDetectionDto,
  IncidentDetectionExcelDownloadDto,
  IncidentDetectionUpdateDto,
} from '../proxy/planning/dtos/incident-detection';
import { INCIDENTDETECTION_CONFIG, INCIDENTDETECTION_FIELDS } from './incident-detection.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-incident-detection',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, IncidentDetectionService, ConfirmationService],
  templateUrl: './incident-detection.html',
  styleUrl: './incident-detection.scss',
})
export class IncidentDetection extends BaseCrudComponent<
  IncidentDetectionDto,
  IncidentDetectionCreateDto,
  IncidentDetectionUpdateDto,
  IncidentDetectionExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(IncidentDetectionService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('IncidentDetection', ids),
  };
  config = INCIDENTDETECTION_CONFIG;
  fields = INCIDENTDETECTION_FIELDS;

  protected prepareUpdateDto(data: any, selected: IncidentDetectionDto): IncidentDetectionUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'IncidentDetection';
  }
}
